import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Tag from '../entities/tag'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface TagState extends ListState<Tag>{
    editTag:Tag;
}
class TagModule extends ListModule<TagState,any,Tag>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Tag>(),
        loading:false,
		editTag:new Tag(),
	}
    actions={
        async getAll(context:ActionContext<TagState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Tag/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Tag>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<TagState,any>,payload:any){
            let reponse = await Ajax.post('/api/services/app/Tag/Create',payload.data);
			return reponse.data.result as Tag;
        },
        async update(context:ActionContext<TagState,any>,payload:any){
            await Ajax.put('/api/services/app/Tag/Update',payload.data);
        },
        async delete(context:ActionContext<TagState,any>,payload:any){
            await Ajax.delete('/api/services/app/Tag/Delete?Id='+payload.id);
        },
        async get(context:ActionContext<TagState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Tag/Get?Id='+payload.id);
            return reponse.data.result as Tag;
        },  
		async tagDetail(context:ActionContext<TagState,any>,payload:any){
		    let reponse=await Ajax.post('/api/services/app/Tag/TagDetail?tagId='+payload.id);
		    return reponse.data.result;
		},	
		async getAllList(context:ActionContext<TagState,any>,payload:any){
		   let reponse=await Ajax.get('/api/services/app/Tag/GetAll',{params:payload.data});
		   return reponse.data.result as PageResult<Tag>;
		},	
			async getAnswerAllList(context:ActionContext<TagState,any>,payload:any){
				  context.state.loading=true;
			   let reponse=await Ajax.get('/api/services/app/Answer/GetAll',{params:payload.data});
			     context.state.loading=true;
			   return reponse.data.result;
			},
			async getAnswerById(content: ActionContext<TagState, any>, payload: any) {
			   let reponse=await Ajax.get('/api/services/app/Answer/Get?Id='+payload.id);
			   return reponse.data.result;		
			},	
    };
    mutations={
        setCurrentPage(state:TagState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:TagState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:TagState,setting:Tag){
            state.editTag=setting;
        }
    }
}
const tagModule=new TagModule();
export default tagModule;